import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AppShell } from "../components/AppShell";
import { authClient } from "../lib/auth-client";
import { TenantProvider } from "../lib/tenant";

/** Pathless layout: everything under it needs a session. */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ location }) => {
    const { data } = await authClient.getSession();
    // Keep the address (a job link from an email, say) so sign-in lands back on it.
    if (!data) throw redirect({ to: "/login", search: { redirect: location.href } });
    return { session: data };
  },
  component: () => (
    <TenantProvider>
      <AppShell>
        <Outlet />
      </AppShell>
    </TenantProvider>
  ),
});
